import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsecasepageService } from '../usecasepage.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-usecases-other-feature',
  standalone: true,
  templateUrl: './usecases-other-feature.component.html',
  styleUrls: ['./usecases-other-feature.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
  encapsulation: ViewEncapsulation.None,
})
export class UsecasesCaseOtherFeatureComponent implements OnInit, OnDestroy {
  @Input() pageData: any;
  @Input() isInside :boolean = false;
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private usecasepageService: UsecasepageService,
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  caseOtherFeatureData: any;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    if (!this.pageData || !this.pageData.fields) {
      return;
    }
    const data = this.pageData.fields;
    if (data != null && data.caseStudyTemplate == 'Template 1') {
      this.caseOtherFeatureData = data?.otherFeaturesContentPanel?.fields;
    }
  }

  onCardClick(cardTitle: string, destinationUrl: string): void {
    const cardType = destinationUrl?.includes('/solutions/') ? 'solution' : 'product';
    const currentUrl = isPlatformBrowser(this.platformId) && typeof window !== 'undefined' 
      ? window.location.pathname 
      : '';
    const pageName = currentUrl.split('/').filter(s => s).pop() || 'home';
    
    this.posthog.captureCardClick(cardTitle, cardType, pageName, {
      destinationUrl: destinationUrl
    });
  }
}
